'use client'

import { useState } from 'react'
import { saveBook2 } from '@/app/actions/bookActions';

interface CollectionDropdownItem {
  id: string;
  name: string;
  isDefault: boolean;
  bookCount: number;
}

interface CollectionsDropdownProps {
  workId: string;
  isVisible: boolean;
  onSaveToCollection: (collectionId: string, collectionName: string) => void;
  savedCollections: string[];
  isSaving: boolean;
  loadingCollections: boolean;
  collections: CollectionDropdownItem[];
  loadCollections: () => void;
}

export default function CollectionsDropdown({
  workId,
  isVisible,
  onSaveToCollection,
  savedCollections,
  isSaving,
  loadingCollections,
  collections,
  loadCollections
}: CollectionsDropdownProps) {
  const [showNewListInput, setShowNewListInput] = useState(false);
  const [newListName, setNewListName] = useState('');
  const [message, setMessage] = useState('');
  
  const handleSaveToNewList = async () => {
    if (!newListName.trim()) return;
    setMessage('');
    
    try {
      const result = await saveBook2(workId, newListName.trim());
      if (result.error) {
        setMessage(result.error);
      } else if (result.success) {
        setMessage(`Book saved to "${newListName}"`);
        setNewListName('');
        setShowNewListInput(false);
        loadCollections();
      }
    } catch (error) {
      console.error('Error saving book:', error);
      setMessage('Error saving book');
    }
  };

  if (!isVisible) return null;
  
  return (
    <div className="" style={{ maxHeight: '90px', overflowY: 'auto' }}>
      {loadingCollections ? (
        <div className="">Loading collections...</div>
      ) : collections.length === 0 && !showNewListInput ? (
        <div className="">
          <div className="">No collections found</div>
          <button 
            onClick={() => setShowNewListInput(true)}
            className="collection-button"
          >
            + Create new list
          </button>
        </div>
      ) : (
        <>
          {collections.map(collection => {
            const isAlreadySaved = savedCollections.includes(collection.id);
            
            return (
              <button
                key={collection.id}
                onClick={() => !isAlreadySaved && onSaveToCollection(collection.id, collection.name)}
                disabled={isSaving || isAlreadySaved}
                className="collection-button"
              >
                {isAlreadySaved
                  ? `Added to "${collection.name.length > 25 ? collection.name.substring(0, 16) + '...' : collection.name}"`
                  : collection.name.length > 25 ? collection.name.substring(0, 25) + '...' : collection.name}
              </button>
            );
          })}
          
          {showNewListInput ? (
            <div className="new-list-form">
              <input
                type="text"
                value={newListName}
                onChange={(e) => setNewListName(e.target.value)}
                placeholder="Enter list name"
                className="new-list-input"
                autoFocus
              />
              <div className="new-list-actions">
                <button
                  onClick={() => {
                    setShowNewListInput(false);
                    setNewListName('');
                  }}
                  className="cancel-button"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSaveToNewList}
                  disabled={isSaving || !newListName.trim()}
                  className="save-button"
                  title='Save new list'
                >
                  {isSaving ? "..." : "Save"}
                </button>
              </div>
            </div>
          ) : (
            <button 
              onClick={() => setShowNewListInput(true)}
              className="collection-button"
            >
              + Create new list
            </button>
          )}
          {message && <div className="message">{message}</div>}
        </>
      )}
    </div>
  );
}